import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationService } from './services/configurationService';
import { TranslateService } from '@ngx-translate/core';
import { RouteGuardService } from './services/routeGuard.service';
import { ApplicationService } from './services/application.service';
import { AppConfigService } from '../app.config.service';
import { httpInterceptorProviders } from './interceptors';
import { InterceptorService } from '@coreModule/services/interceptorService';
import { AdobeAnalyticsService } from '@coreModule/services/adobe-analytics.service';
import { TrackingGlobals } from '@shared/enum/trackingGlobals';
import { DynatraceLogService } from './services/dynatraceLog.service';
import { CanDeactivateService } from './services/canDeactivateService';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    AppConfigService,
    ConfigurationService,
    TranslateService,
    RouteGuardService,
    ApplicationService,
    InterceptorService,
    httpInterceptorProviders,
    AdobeAnalyticsService,
    TrackingGlobals,
    DynatraceLogService,
    CanDeactivateService
  ]
})
export class CoreModule {}
